export default __webpack_public_path__ + "static/media/visa.d142fb37.png";